import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'

Vue.use(Vuex)

// State storage and map layer defaults
export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    toggle: {
      imagry: {
        summer_2014_40cm: false
      },
      signshop: {
        signage: false
      },
      dialog: {
        help: false,
        legal: false,
        login: false,
        add: {
          point: false
        }
      }
    },
    dialogs: {
      ui: {
        dialogHelp: false,
        dialogLegal: false,
        dialogLogin: false,
        dialogChangePassword: false
      },
      addGeometry: {
        dialogSelectPointLayer: false,
        dialogSelectLineLayer: false,
        dialogSelectPolygonLayer: false
      }
    },
    layers: {
      snowmaking: {
        id: 0,
        name: 'snowmaking',
        deptTitle: 'Snowmaking',
        mapLayers: {
          hydrants: {
            name: 'hydrants',
            id: 1,
            layerTitle: 'Hydrants',
            geojson: [],
            visibility: {
              mapView: false,
              listView: false
            },
            type: 'Point',
            isEditable: true,
            components: {
              list: 'components/snowmaking/hydrants/list.vue',
              single: 'components/snowmaking/hydrants/single.vue',
              edit: 'components/snowmaking/hydrants/edit.vue'
            },
            mixin: 'mixins/snowmaking/hydrants/mixin.js',
            apiMethodUrl: {
              readAll: 'https://api.alchemymapping.com/wb/snowmaking/hydrants',
              readSingle: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id',
              create: 'https://api.alchemymapping.com/wb/snowmaking/hydrants',
              update: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id',
              delete: 'https://api.alchemymapping.com/wb/snowmaking/hydrants/:id'
            }
          }
        }
      },
      liftmaintenance: {
        id: 2,
        name: 'liftmaintenance',
        deptTitle: 'Lift Maintenance',
        mapLayers: {
          cables: {
            name: 'cables',
            id: 3,
            layerTitle: 'Lift Cables',
            geojson: [],
            visibility: {
              mapView: false,
              listView: false
            },
            type: 'LineString',
            isEditable: false,
            components: {
              list: 'components/liftmaintenance/cables/list.vue',
              single: 'components/liftmaintenance/cables/single.vue',
              edit: 'components/liftmaintenance/cables/edit.vue'
            },
            mixin: 'mixins/liftmaintenance/cables/mixin.js',
            apiMethodUrl: {
              readAll: 'https://api.alchemymapping.com/wb/liftmaintenance/cables',
              readSingle: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id',
              create: 'https://api.alchemymapping.com/wb/liftmaintenance/cables',
              update: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id',
              delete: 'https://api.alchemymapping.com/wb/liftmaintenance/cables/:id'
            }
          }
        }
      }
    },
    general: {
      title: 'GeoWB',
      copyrightNotice: 'The GeoWB website, application and back end infrastructure is copyright 2018 by Mike Hamilton and Alchemy Mapping Solutions, Inc.',
      copyrightNoticeShort: '© 2018 Alchemy Mapping Solutions/Mike Hamilton',
      copyrightData: 'All GIS data is by Heather Dufty and is copyright 2016-2018 Whistler Blackcomb.'
    },
    geojson: {
      snowmaking: {
        hydrants: []
      },
      liftmaintenance: {
        cables: []
      }
    }
  },
  actions: {
    actionGetGeoJson: function ({ commit }, layerData) {
      axios.get(layerData.url).then((response) => {
        commit('mutationGetGeoJson', {
          data: response.data,
          dept: layerData.dept,
          layer: layerData.layer
        })
      }, (err) => {
        console.log(err)
      })
    }
  },
  mutations: {
    mutationGetGeoJson: (state, { data, dept, layer }) => {
      function jsonEqual (a, b) {
        return JSON.stringify(a) === JSON.stringify(b)
      }
      if (!jsonEqual(state.layers[dept].mapLayers[layer].geojson, data)) {
        state.layers[dept].mapLayers[layer].geojson = data
      }
    },
    mutationDialogUi (state, payload) {
      state.dialogs.ui[payload.dialog] = !state.dialogs.ui[payload.dialog]
    },
    toggleSummer2014 (state) {
      state.toggle.imagry.summer_2014_40cm = !state.toggle.imagry.summer_2014_40cm
    },
    toggleDialogHelp (state) {
      state.toggle.dialog.help = !state.toggle.dialog.help
    },
    toggleDialogLegal (state) {
      state.toggle.dialog.legal = !state.toggle.dialog.legal
    },
    toggleDialogLogin (state) {
      state.toggle.dialog.login = !state.toggle.dialog.login
    },
    toggleDialogAddPoint (state) {
      state.toggle.dialog.add.point = !state.toggle.dialog.add.point
    },
    toggleDataSnowmakingHydrants (state) {
      state.toggle.data.snowmaking.hydrants = !state.toggle.data.snowmaking.hydrants
    },
    toggleDataLiftmaintenanceCables (state) {
      state.toggle.data.liftmaintenance.cables = !state.toggle.data.liftmaintenance.cables
    },
    mutationMapLayer (state, payload) {
      state.layers[payload.dept].mapLayers[payload.layer].visibility.mapView = !state.layers[payload.dept].mapLayers[payload.layer].visibility.mapView
    },
    mutationListLayer (state, payload) {
      state.layers[payload.dept].mapLayers[payload.layer].visibility.listView = !state.layers[payload.dept].mapLayers[payload.layer].visibility.listView
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js